import { DollarOutlined, UserOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import { PoolDetailStats } from '../types'

type Props = {
  data: PoolDetailStats
}

const formatAmount = (value: number, fractionDigits: number) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)

const PoolDetailOverview = ({ data }: Props) => {
  const cards = [
    {
      label: 'Total Stakers',
      value: formatAmount(data.totalStakers, 0),
      icon: <UserOutlined />,
    },
    {
      label: 'Total Staked Amount',
      value: `${formatAmount(data.totalStakedAmount, 0)} ${data.stakedSymbol}`,
      icon: <DollarOutlined />,
    },
    {
      label: 'Total Reward Claimed',
      value: `${formatAmount(data.totalRewardClaimed, 3)} ${data.rewardUnit}`,
      icon: <DollarOutlined />,
    },
    {
      label: 'Total Reward Unclaimed',
      value:
        data.totalRewardUnclaimed == null ? (
          <Tooltip title="Could not read from chain">
            <span>Unavailable</span>
          </Tooltip>
        ) : (
          `${formatAmount(data.totalRewardUnclaimed, 3)} ${data.rewardUnit}`
        ),
      icon: <DollarOutlined />,
    },
  ]

  return (
    <div className="dashboard-container">
      <div className="wrap-dashboard">
        <div className="wrap-box">
          <div className="title">Staked Overview</div>
          <div className="wrap-columns">
            <div className="columns">
              {cards.map((card) => (
                <div className="colum w-3" key={card.label}>
                  <div className="guide-box">
                    <div className="box-content">
                      <div className="left-s">
                        <div className="txt">{card.label}</div>
                        <div className="number">{card.value}</div>
                      </div>
                      <div className="right-s">
                        <div className="icon">{card.icon}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PoolDetailOverview
